import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/market.reg.module.scss';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useUploadFileHook from 'src/webapp/hooks/comn/uploadFile.hook';
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import DataFieldWrapper from './MarketReg.DataField.Wrapper';//입력 및 선택 폼 wrapper
import InputField from './MarketReg.DataField.InputField';//입력필드
import DataFieldList from './MarketReg.DataField.List';//배열데이터(선택)

const MarketRegDataField = forwardRef((props, childRef) => {
    const { state } = useLocation();
    const params = useParams();
    /* =============== 상위컴포넌트에서 호출 =============== */
    useImperativeHandle(childRef, () => ({//
        marketRegAndUpdateAPI
    }));
    /* =============== 상위컴포넌트에서 호출 =============== */
    
    const { data, isDisabled, setDisabled, type } = props;//props
    const { axiosPostHandler, axiosMultiPartHandler } = useAxiosHook();//axios
    const navigator = useNavigate();//navigator
    //store
    const { setMessage } = useComnStore();//메세지결과처리
    const { partner } = usePartnerStore();
    //hook
    const { files, //fileuseState
        setFiles,
        MAX_COUNT,//최대업로드갯수
        addFilesHandler,//파일업로드핸들러
        removeFilesHandler//파일선택삭제
    } = useUploadFileHook();
    const { initPhoneNumberFormat } = useComnHook();

    /* =============== 이미지최대등록가능수 =============== */
    useEffect(() => {
        MAX_COUNT.current = 5;
    }, []);
    /* =============== 이미지최대등록가능수 =============== */
    /* =============== 체크항목 =============== */
    const [checked, setChecked] = useState({ category: null, range: null, used: null, method: null });
    /* =============== 체크항목 =============== */
    /* =============== 입력필드 =============== */
    const inputRef = useRef([]);
    /* =============== 입력필드 =============== */
    /* =============== 마켓수정 최초데이터 셋 =============== */
    /* ===== 할인율제외 나머지 데이터 ===== */
    const [ init,setInit ] = useState(false);
    useEffect(() => {(async () => {
        if(state === null) { return; }

        setFiles(state.IMG_LIST);
        setChecked({ category:state.CATEGORY, range:state.RANGE, used:state.USED_LVL, method:state.TRADE_METHOD });
        setInputValid(true);
        for(let i = 0; i < inputRef.current.length; i++) {
            switch(i) {
                case 0 : inputRef.current[i].value = state.SUBJECT ?? ''; break;
                case 1 : inputRef.current[i].value = state.INIT_PRICE ?? ''; break;
                case 3 : inputRef.current[i].value = state.CONT ?? (state.CATEGORY === 1 || state.CATEGORY === 2 ? memo1 + `\n` + memo2 : memo2); break;
                case 5 : inputRef.current[i].value = initPhoneNumberFormat(state.TEL_NO?.toString()); break;
            }
        }
    })()}, []);
    /* ===== 할인율적용 ===== */
    useEffect(() => {
        if(state === null) { return; }
        if(checked.range !== 1 && checked.range !== 3) { return; }

        inputRef.current[2].value = state.DISCOUNT ?? '';
        
    }, [checked.range])
    /* =============== 마켓수정 최초데이터 셋 =============== */
    /* =============== 설명내용(차량선택시 memo1추가) =============== */
    const memo1 = `-제작사, 모델명 : \n-연식 : \n-적산거리 : \n-사고 및 슬립 여부 등 : \n-대차 가능여부 : `;
    const memo2 = `-사용기간 혹은 사이즈 : \n-부속품 여부 : \n-그 외 상품 관련 설명 : `;
    useEffect(() => {(async () => {
        //if(inputRef.current[3] === undefined || type == 2) { return; }
        if(inputRef.current[3] === undefined ||  checked.category === null) { return; }

        let newData = checked.category !== null && (checked.category === 1 || checked.category === 2) ? memo1 + `\n` + memo2 : memo2;
        newData = state !== null && !init ? state.CONT : state !== null && checked.category === state.CATEGORY ? state.CONT : newData;
        inputRef.current[3].value = newData;
        setInit(true);
    })()}, [checked.category]);
    /* =============== 설명내용(차량선택시 memo1추가) =============== */
    /* =============== 입력 및 선택값 검증 =============== */
    /* 입력값 */
    const [ inputValid,setInputValid ] = useState(false);
    /* 선택값 */
    const checkedValidation = async() => {
        let valid = true;
        for(let i = 0; i < Object.keys(checked).length; i++) {
            if(Object.values(checked)[i] === null) { valid = false; break; }
        }
        return valid;
    }
    useEffect(() => {(async () => {
        const checkedValid = await checkedValidation();
        const valid = type == 1 ? ((checkedValid && inputValid && files.length > 0 ) ? false : true) : ((checkedValid && inputValid) ? false : true);
        if(isDisabled !== valid) {
            setDisabled(valid);
        }
    })()}, [checked, inputValid, files]);
    /* =============== 입력 및 선택값 검증 =============== */
    /* =============== 마켓 등록 및 수정 =============== */
    const isLock = useRef(false);
    const marketRegAndUpdateAPI = async() => {//type 1.등록 2.수정 3.삭제
        if(isLock.current) { return; }

        setMessage({type:2, message:`잠시만 기다려주세요.`});
        const DATA = { SEQ_NO: type === 2 ? params.seq : 0
            , PARTNER_CD:partner.COMN_CD
            , CATEGORY:checked.category
            , RANGE:checked.range
            , USED_LVL:checked.used
            , TRADE_METHOD:checked.method
            , SUBMIT_TYPE:type, STATUS : 1//거래상태 - 1.거래가능, 2.예약중, 3.거래완료, D.삭제
            , SUBJECT:inputRef.current[0]?.value ?? null
            , PRICE:inputRef.current[1]?.value?.replaceAll(',', '') ?? 0
            , DISCOUNT: inputRef.current[2]?.value?.length <= 0 ? 0 : inputRef.current[2]?.value?.replaceAll(',', '') ?? 0
            , CONT:inputRef.current[3]?.value ?? null
            , TEL_NO:inputRef.current[5]?.value?.replaceAll('-', '') ?? 0
        };
        const result = await axiosPostHandler(`marketRegAndUpdateForJson.do`,DATA);
        if(!result || result.message !== "SUCCESS") { 
            setMessage({type:2, message:`잠시 후 다시 시도해주세요.`});
            setTimeout(function() { isLock.current = false; }, 300); return; 
        }
        if(result.message === 'SUCCESS'){
            if(files.length <= 0){
                setMessage({type:1, message:(type === 1 ? `등록` : `수정`) + `이 완료되었습니다.`});
                navigator(-1);
                return;
            }
            marketImgRegAndUpdateAPI(result.data, type);//이미지등록api실행
        }
    }
    /* =============== 마켓 등록 및 수정 =============== */
    /* =============== 마켓 이미지 등록 및 수정 =============== */
    const marketImgRegAndUpdateAPI = async(res, type) => {
        const DATA = new FormData();
        let IMG_LIST = [];
        for(let i = 0; i < files.length; i++) {
            if(files[i].file === undefined && files[i].IDX !== undefined) { IMG_LIST.push(files[i].IDX) }
            if(files[i].file !== undefined && files[i].IDX === undefined) { DATA.append('file', files[i].file); }
        }
        const variables = { SEQ_NO:res.result, PARTNER_CD:partner.COMN_CD, IMG_LIST:(type === 1 ? [] : IMG_LIST) };
        DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
        const result = await axiosMultiPartHandler(`marketImgRegAndUpdateForPartner.do`, DATA);
        setTimeout(function() { isLock.current = false; }, 300);
        // if(!result || result.message !== "SUCCESS") { setMessage({type:2, message:`잠시 후 다시 시도해주세요.`}); return; }
        if(result.message === "SUCCESS"){
            setMessage({type:1, message:(type === 1 ? `등록` : `수정`) + `이 완료되었습니다.`});
        }
        navigator(-1); 
    }
    /* =============== 마켓 이미지 등록 및 수정 =============== */

    return (
        <Element tag={`div`} className={styles.marketContainer}>
            {/* START 이미지 선택 */}
            <Element tag={`div`} className={styles.imgContainer}>
                {files.length < MAX_COUNT.current ?
                    <Element tag={`button`} anyprop={(e) => document.getElementById("file").click()}>
                        <FontAwesomeIcon icon="fa-solid fa-camera" />
                        <Element tag={`label`}>{files.length}/{MAX_COUNT.current}</Element>
                        <input onChange={(e) => addFilesHandler(e)} type="file" id="file" multiple />
                    </Element>
                : null}
                {files.length > 0 && files.map((file, idx) => (
                    <React.Fragment key={idx}>
                        <Element tag={`div`}>
                            <img src={file.url ?? `${process.env.REACT_APP_IMAGE_URL + file.IMG_SRC}`} alt="preview-img" />
                            <Element tag={`button`} anyprop={(e) => removeFilesHandler(file)}><FontAwesomeIcon icon="fa-light fa-xmark" /></Element>
                        </Element>
                    </React.Fragment>
                ))}
            </Element>
            {/* START 입력 및 선택 */}
            <DataFieldWrapper title={`제목입력`}>
                <InputField type={1} inputRef={inputRef} propRef={el => (inputRef.current[0] = el)} placeholder={`제목을 입력해주세요`} setInputValid={setInputValid} />
                <DataFieldList type={'category'} checked={checked} setChecked={setChecked} />
            </DataFieldWrapper>
            <DataFieldWrapper title={`노출범위`}>
                    <DataFieldList type={'range'} checked={checked} setChecked={setChecked} />
            </DataFieldWrapper>
            <DataFieldWrapper title={`거래방식`}>
                <DataFieldList type={'method'} checked={checked} setChecked={setChecked} />
                <InputField type={1} inputRef={inputRef} propRef={el => (inputRef.current[1] = el)} placeholder={`₩ 가격을 입력해주세요`} setInputValid={setInputValid} change={1} />
                {checked.range !== null && (checked.range === 1 || checked.range === 3) ?
                    <InputField type={1} inputRef={inputRef} propRef={el => (inputRef.current[2] = el)} placeholder={`% 할인율을 입력해주세요(할인은 파트너에만 적용되어요)`} setInputValid={setInputValid} change={3} />
                : null}
            </DataFieldWrapper>
            <DataFieldWrapper title={`설명`}>
                    <InputField type={2} inputRef={inputRef} propRef={el => (inputRef.current[3] = el)} placeholder={`게시글 내용을 작성해 주세요.(판매 금지 물품은 게시가 제한될 수 있어요.)\n\n신뢰할 수 있는 거래를 위해 자세히 적어주세요.`} setInputValid={setInputValid} />
            </DataFieldWrapper>
            <DataFieldWrapper title={`사용감`}>
                <DataFieldList type={'used'} checked={checked} setChecked={setChecked} />
            </DataFieldWrapper>
            <DataFieldWrapper title={`거래시 연락처`}>
                <InputField type={1} inputRef={inputRef} propRef={el => (inputRef.current[5] = el)} placeholder={`거래시 연락받을 연락처를 입력해주세요`} setInputValid={setInputValid} change={2} />
            </DataFieldWrapper>
        </Element>
    );
})
export default MarketRegDataField;